import { render, staticRenderFns } from "./DataBannerWebpart.vue?vue&type=template&id=58266506"
import script from "./DataBannerWebpart.ts?vue&type=script&lang=ts&external"
export * from "./DataBannerWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports